<template>
  <div
    class="relative flex flex-col justify-center items-center w-full h-full lg:pt-5"
  >
    <section-title titlePath="title-3.png" />
    <div class="btns flex flex-row justify-center w-full xl:visible">
      <div
        v-for="(menu, index) in menuData"
        :key="index"
        :class="{ menuActive: menu.isActive }"
        class="cursor-pointer w-226 h-78 m-3 text-white font-elmessiri text-xl flex justify-center items-center bg-auto bg-btn bg-10-10 hover:bg-10-108"
        @click="handleMenu(index)"
      >
        {{ menu.text }}
      </div>
    </div>
    <transition-group
      name="fade"
      tag="div"
      class="relative w-full h-538 mt-14 flex justify-center items-start z-20 xl:mt-6 xl:h-720 lg:h-auto"
    >
      <!-- main class -->
      <card-cont
        v-show="menuData[0].isActive"
        class="card-container absolute w-full max-w-1264 flex flex-wrap justify-center mx-auto xl:max-w-800 lg:px-20"
        :classData="mainClassData"
        :key="menuData[0].text"
      />

      <!-- sub class -->
      <card-cont
        v-show="menuData[1].isActive"
        class="absolute card-container w-full max-w-1056 flex flex-wrap justify-center mx-auto xl:max-w-800 lg:px-20"
        :classData="subClassData"
        :key="menuData[1].text"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CardCont from '../components/CardCont/CardCont.vue';
import ClassSlider from '../components/ClassSlider/ClassSlider.vue';
import SectionTitle from '../components/SectionTitle/SectionTitle.vue';
export default {
  components: { SectionTitle, CardCont, ClassSlider },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      mainClassData: [
        {
          face: '/slide4/Main/main_card1.png',

          classes: [
            {
              id: 0,
              icon: '/slide4/Icons/ico_main1_1.png',
              title: 'Hero',
            },
            {
              id: 1,
              icon: '/slide4/Icons/ico_main1_2.png',
              title: 'Blade Master',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card2.png',

          classes: [
            {
              id: 2,
              icon: '/slide4/Icons/ico_main2_1.png',
              title: 'Savior',
            },
            {
              id: 3,
              icon: '/slide4/Icons/ico_main2_2.png',
              title: 'sefirot',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card3.png',

          classes: [
            {
              id: 4,
              icon: '/slide4/Icons/ico_main3_1.png',
              title: 'Archmage',
            },
            {
              id: 5,
              icon: '/slide4/Icons/ico_main3_2.png',
              title: 'Pop Star',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card4.png',

          classes: [
            {
              id: 6,
              icon: '/slide4/Icons/ico_main4_1.png',
              title: 'Wind Stalker',
            },
            {
              id: 7,
              icon: '/slide4/Icons/ico_main4_2.png',
              title: 'Der Freischütz',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card5.png',

          classes: [
            {
              id: 8,
              icon: '/slide4/Icons/ico_main5.png',
              title: 'Swordian',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card6.png',
          classes: [
            {
              id: 9,
              icon: '/slide4/Icons/ico_main6.png',
              title: 'Souless One',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card7.png',
          classes: [
            {
              id: 10,
              icon: '/slide4/Icons/ico_main7_1.png',
              title: 'Arc Master',
            },
            {
              id: 11,
              icon: '/slide4/Icons/ico_main7_2.png',
              title: 'Force Master',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card8.png',
          classes: [
            {
              id: 12,
              icon: '/slide4/Icons/ico_main8.png',
              title: 'Black Anima',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card9.png',
          classes: [
            {
              id: 13,
              icon: '/slide4/Icons/ico_main9.png',
              title: 'Demigod',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card10.png',
          classes: [
            {
              id: 14,
              icon: '/slide4/Icons/ico_main10.png',
              title: 'Agni',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card11.png',
          classes: [
            {
              id: 15,
              icon: '/slide4/Icons/ico_main11.png',
              title: 'Dark Chaser',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card12.png',
          classes: [
            {
              id: 16,
              icon: '/slide4/Icons/ico_main12.png',
              title: 'Shadow Walker',
            },
          ],
        },
      ],
      // Sub class
      subClassData: [
        {
          face: '/slide4/Sub/sub_card1.png',

          classes: [
            {
              id: 0,
              icon: '/slide4/Icons/ico_sub1.png',
              title: 'HighLander',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card2.png',

          classes: [
            {
              id: 1,
              icon: '/slide4/Icons/ico_sub2.png',
              title: 'Sword Dancer',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card3.png',

          classes: [
            {
              id: 2,
              icon: '/slide4/Icons/ico_sub3.png',
              title: 'Terror Knight',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card4.png',

          classes: [
            {
              id: 3,
              icon: '/slide4/Icons/ico_sub4.png',
              title: 'Psykicker',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card5.png',

          classes: [
            {
              id: 4,
              icon: '/slide4/Icons/ico_sub5.png',
              title: 'Phantom Mage',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card6.png',
          classes: [
            {
              id: 5,
              icon: '/slide4/Icons/ico_sub6.png',
              title: 'Maestro',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card7.png',
          classes: [
            {
              id: 6,
              icon: '/slide4/Icons/ico_sub7.png',
              title: 'Rogue Master',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card8.png',
          classes: [
            {
              id: 7,
              icon: '/slide4/Icons/ico_sub8.png',
              title: 'Judgment',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card9.png',
          classes: [
            {
              id: 8,
              icon: '/slide4/Icons/ico_sub9.png',
              title: 'Star Seeker',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card10.png',
          classes: [
            {
              id: 9,
              icon: '/slide4/Icons/ico_sub10.png',
              title: 'Jewel Star',
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleMenu: function(menuIndex) {
      this.$store.commit('CLASS_SECTION/HANDLE_MENU', menuIndex);
    },
  },
  computed: {
    ...mapState({
      menuData: state => state.ClassSection.menuData,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.btns .menuActive {
  @apply bg-10-108;
}
</style>
